import { render, staticRenderFns } from "./controllers.vue?vue&type=template&id=66085de7&lang=pug"
import script from "./controllers.vue?vue&type=script&lang=js"
export * from "./controllers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports